export default __webpack_public_path__ + "locales/hy-AM/InviteDialog.json?hash=3cc19e3dd89551579444560de1628188";